<div class="regiment-container">
  <!-- Header -->
  <div class="regiment-header">
    <div class="header-content">
      <h2 class="regiment-title">Weekly Training Regiment</h2>
      <span class="week-range" *ngIf="regiment">{{ getWeekDateRange() }}</span>
    </div>
  </div>

  <!-- Test Profile Selector -->
  <div class="test-profile-selector">
    <ion-item lines="none" class="profile-select-item">
      <ion-label class="profile-label">Test Profile:</ion-label>
      <ion-select 
        [(ngModel)]="selectedProfileId" 
        (ionChange)="onProfileChange()"
        placeholder="Select Profile"
        class="profile-select">
        <ion-select-option 
          *ngFor="let profile of testProfiles" 
          [value]="profile.id">
          {{ profile.name }}
        </ion-select-option>
      </ion-select>
    </ion-item>
    <p class="profile-description" *ngIf="selectedProfileId !== 'real'">
      {{ getSelectedProfileDescription() }}
    </p>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading">
    <ion-spinner name="crescent"></ion-spinner>
    <p>Loading your training plan...</p>
  </div>

  <!-- Error State -->
  <div class="error-state" *ngIf="hasError && !isLoading">
    <ion-icon name="alert-circle-outline"></ion-icon>
    <p>{{ errorMessage }}</p>
    <ion-button fill="outline" size="small" (click)="loadRegiment()">
      Retry
    </ion-button>
  </div>

  <!-- Regiment Content -->
  <div class="regiment-content" *ngIf="regiment && !isLoading && !hasError">
    
    <!-- Assessment Level Badge -->
    <div class="assessment-level-section">
      <div class="level-badge" [ngClass]="getAssessmentLevelClass()">
        <span class="level-label">{{ regiment.overallAssessmentLevel }}</span>
        <span class="level-score">Score: {{ regiment.overallAverageScore | number:'1.1-1' }}</span>
      </div>
      <p class="level-description">{{ getAssessmentLevelDescription() }}</p>
    </div>

    <!-- Training Recommendations -->
    <div class="training-section">
      <h3 class="section-title" [@headerFade]>This Week's Training Plan</h3>
      
      <div class="training-list">
        <div 
          #trainingItem
          class="training-item clickable" 
          *ngFor="let rec of regiment.trainingRecommendations; trackBy: trackByTrainingType"
          [ngClass]="getTrainingClass(rec)"
          [@trainingList]="getItemAnimationState(rec.trainingType)"
          [@trainingItemExpand]="selectedTrainingType === rec.trainingType ? 'expanding' : 'normal'"
          (click)="onTrainingItemClick($event, rec, trainingItem)"
          [class.is-selected]="selectedTrainingType === rec.trainingType"
          [class.is-transitioning]="isTransitioning && selectedTrainingType !== rec.trainingType">
          
          <div class="training-header">
            <div class="training-icon-wrapper" #iconWrapper>
              <img [src]="rec.iconPath" [alt]="rec.displayName" class="training-icon">
            </div>
            <div class="training-info">
              <span class="training-name">{{ rec.displayName }}</span>
              <span class="adjustment-badge" *ngIf="rec.adjustment !== 0">
                {{ getAdjustmentLabel(rec) }}
              </span>
            </div>
            <div class="training-progress">
              <span class="progress-text">{{ getCompletedCount(rec) }}/{{ rec.sessionsPerWeek }}</span>
            </div>
            <!-- Chevron indicator for clickable items -->
            <div class="training-chevron">
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </div>
          </div>

          <!-- Session Circles -->
          <div class="session-circles" (click)="$event.stopPropagation()">
            <button 
              *ngFor="let completed of rec.sessionsCompleted; let i = index"
              class="session-circle"
              [class.completed]="completed"
              (click)="toggleSession(rec, i)"
              [attr.aria-label]="'Session ' + (i + 1) + (completed ? ' completed' : ' not completed')">
              <ion-icon *ngIf="completed" name="checkmark"></ion-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Focus Areas -->
    <div class="focus-section" *ngIf="hasFocusAreas()">
      <h3 class="section-title">Focus Areas</h3>
      <p class="focus-description">{{ getFocusAreasSummary() }}</p>
      
      <div class="focus-tags">
        <span 
          class="focus-tag" 
          *ngFor="let flag of regiment.subscoreFlags">
          {{ flag.category }}
          <span class="focus-score">({{ flag.score | number:'1.1-1' }})</span>
        </span>
      </div>
    </div>

    <!-- No Focus Areas Message -->
    <div class="focus-section no-focus" *ngIf="!hasFocusAreas()">
      <h3 class="section-title">Focus Areas</h3>
      <p class="focus-description">{{ getFocusAreasSummary() }}</p>
    </div>

  </div>

  <!-- No Regiment State -->
  <div class="no-regiment-state" *ngIf="!regiment && !isLoading && !hasError">
    <ion-icon name="clipboard-outline"></ion-icon>
    <p>Complete an assessment to generate your personalized training regiment.</p>
  </div>
</div>
